import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Window, UpdateWindowDto } from 'types';

export const updateWindow = async ({
  data,
  windowId,
}: {
  data: UpdateWindowDto;
  windowId: number;
}): Promise<Window> => {
  const response = await axios.put(`/api/windows/${windowId}`, data);
  return response.data as Window;
};

type UseUpdateWindowOptions = {
  config?: MutationConfig<typeof updateWindow>;
};

export const useUpdateWindow = ({ config }: UseUpdateWindowOptions) => {
  return useMutation({
    onMutate: async (updatingWindow: any) => {
      await queryClient.cancelQueries(['window', updatingWindow?.id]);

      const previousWindow = queryClient.getQueryData<Window>([
        'window',
        updatingWindow?.id,
      ]);

      queryClient.setQueryData(['windows', updatingWindow?.id], {
        ...previousWindow,
        ...updatingWindow.data,
        id: updatingWindow.id,
      });

      return previousWindow;
    },
    onError: (_, __, context: any) => {
      if (context?.previousWindow) {
        queryClient.setQueryData(
          ['windows', context.previousWindow.id],
          context.previousWindow
        );
      }
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['window', data?.id]);
      queryClient.invalidateQueries(['wall', data?.wall_id]);
      queryClient.invalidateQueries(['windows', data?.wall_id]);
    },
    ...config,
    mutationFn: updateWindow,
  });
};
